import forEach from 'lodash/forEach';

import {
    HEADER_BACKGROUNDS,
    HEADER_BACKGROUND_BREAKPOINTS,
} from '../constants/background';

const getBoundedIndex = (imageIndex) => (imageIndex % HEADER_BACKGROUNDS.length);

export const getImageForBreakpoint = ({windowWidth, imageIndex} = {}) => {
    const boundedImageIndex = getBoundedIndex(imageIndex);
    const imagesSet = HEADER_BACKGROUNDS[boundedImageIndex].images;

    let imageUrl = imagesSet.mobile;

    if (windowWidth) {
        forEach(HEADER_BACKGROUND_BREAKPOINTS, (breakpointSize, keyName) => {
            if (windowWidth >= breakpointSize) {
                imageUrl = imagesSet[keyName];
            }
        });
    }

    return imageUrl;
};

export const getAttributionForImage = ({imageIndex}) => {
    const boundedImageIndex = getBoundedIndex(imageIndex);

    return HEADER_BACKGROUNDS[boundedImageIndex].attribution || '';
};
